// Customize this 'myform.js' script and add it to your JS bundle.
// Then import it with 'import MyForm from "./myform.js"'.
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React from "react";
import { LanguageContext } from "../../../Contexts/LanguageContext";
import './Apply.css'

export default class MyForm extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.state = {
            status: ""
        };
    }

    render() {
        const { status } = this.state;
        const isBangla = this.context[0];
        return (
            <form
                onSubmit={this.submitForm}
                action="https://formspree.io/f/xyybbppw"
                method="POST"
            >
                {/* <!-- add your custom form HTML here --> */}
                <div className="container">
                    <div className="container text-center">
                        <h1>{isBangla ? "আবেদন করুন" : "Apply"}</h1>
                    </div>
                    <label>{isBangla ? "নাম:" : "Name:"}</label>
                    <input className="form-control" type="name" name="name" placeholder="Enter your name" />
                    <label className="mt-4">{isBangla ? "ইমেইল:" : "Email:"}</label>
                    <input className="form-control" type="email" name="email" placeholder="Enter your email" />
                    <label className="mt-4">{isBangla ? "মোবাইল নং:" : "Phone Number:"}</label>
                    <input className="form-control" type="phone" name="phone" placeholder="Enter your phone" />
                    <label className="mt-4">{isBangla ? <span>এমেইলে সিভি বা রেসুমে পাঠান: <a href="mailto:biotech.pharma@yahoo.com" className="click-here" > Click Here</a></span> : <span>Submit CV Or Resume in Email: <a href="mailto:biotech.pharma@yahoo.com" className="click-here" > Click Here</a></span>}</label>
                    <br/>
                    {status === "SUCCESS" ? <p>Thanks!</p> : <button className="mt-4 mb-5 submit-btn">{isBangla ? "জমা দিন" : "Submit"}</button>}
                    {status === "ERROR" && <p>Ooops! There was an error.</p>}
                </div>
            </form>
        );
    }

    submitForm(ev) {
        ev.preventDefault();
        const form = ev.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                this.setState({ status: "SUCCESS" });
            } else {
                this.setState({ status: "ERROR" });
            }
        };
        xhr.send(data);
    }
}